import LocalizedStrings from 'react-localization';
import us from './us';
import { IStrings } from './types';

const strings = new LocalizedStrings<IStrings>({
  us
});

export default strings;
